import { render, staticRenderFns } from "./relateDetection.vue?vue&type=template&id=980f2c88&scoped=true"
import script from "./relateDetection.vue?vue&type=script&lang=ts"
export * from "./relateDetection.vue?vue&type=script&lang=ts"
import style0 from "./relateDetection.vue?vue&type=style&index=0&id=980f2c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980f2c88",
  null
  
)

export default component.exports